import React, { useEffect, useState } from "react";
import { gettext } from "web/script/modules/django-i18n";
import analytics from "web/script/analytics/analytics";
import environment from "web/script/modules/environment";
import SendToAppModal from "web/react/components/send-to-app-modal/send-to-app-modal";
import { RawBranchLink } from "web/script/utils/branch-io";
import browser from "web/script/utils/browser";
import userProfiler from "web/script/modules/userprofiler";
import history from "web/script/utils/history";
import { useOverlayWatcher } from "web/react/hooks/use-overlay-watcher/use-overlay-watcher";
import globals from "web/script/modules/globals";
import classnames from "classnames";
import PrimaryButton from "web/react/components/buttons/primary-button/primary-button";
import styles from "./related-products-show-more.css";

const HARD_BLOCK = "hard_block";
const NO_BLOCK = "no_block";
const APP_MODAL_NAME = "send-to-app-on-oos-related-show-more-modal";

interface RelatedProductsSectionProp {
    view_more_url: string;
    product_is_instock?: boolean;
}

export function RelatedProductsShowMore(section: RelatedProductsSectionProp): JSX.Element {
    const isIos = browser.ios;
    const productIsInstock = section.product_is_instock != null && section.product_is_instock;
    let blockVariant;

    if (isIos && !userProfiler.isLoggedIn() && environment.get("domainDefaultLanguageIsEnglish")) {
        blockVariant = HARD_BLOCK;
    } else {
        blockVariant = NO_BLOCK;
    }

    const blockModalIsOpen = !!useOverlayWatcher(APP_MODAL_NAME);

    const branchLink = productIsInstock
        ? RawBranchLink.InStockShowMore
        : RawBranchLink.OutOfStockShowMore;

    let blockingTitle = productIsInstock
        ? // "Shop the world’s biggest and best selection of fashion"
          gettext("in_stock_product.related_show_more.app_overlay_block.title_1")
        : // "The hottest and newest products from over 12,000 brands"
          gettext("oos_product.related_show_more.app_overlay_block.title_2");

    function onBlockModalOpen(): void {
        // I check the current overlay state instead of modalIsOpen
        // to get around the delay introduced by hooks
        if (history.getCurrentState().overlay !== APP_MODAL_NAME) {
            history.pushOverlay(APP_MODAL_NAME);
        }
    }

    function onButtonClick(): void {
        analytics.event("navigation", "show_more_related", "show_feed");
        const isPlaUtmCampaign = environment.get("isPlaUtmCampaign") && productIsInstock;
        if (blockVariant === HARD_BLOCK && !isPlaUtmCampaign) {
            onBlockModalOpen();
            return;
        }
        // If we don't meet the requirements to open the modal, we use default behaviour
        globals.window.location.href = section.view_more_url;
    }

    function onBlockModalClose(): void {
        history.popOverlay(APP_MODAL_NAME);
    }

    const [isPaywalled, setIsPaywalled] = useState(false);
    const paywalledClassName = "paywalled-content";
    useEffect(() => {
        setIsPaywalled(blockVariant === HARD_BLOCK);
    }, [blockVariant]);

    return (
        <div className={classnames({ [paywalledClassName]: isPaywalled })}>
            <PrimaryButton className={styles.showMoreButton} onClick={onButtonClick}>
                {gettext("product.related_products.show_me_more")}
            </PrimaryButton>
            <SendToAppModal
                title={blockingTitle}
                url={branchLink}
                isOpen={blockModalIsOpen}
                onClose={onBlockModalClose}
                analyticsEventLabel={"oos_related_show_more"}
                paywalledClassName={isPaywalled ? paywalledClassName : null}
            />
        </div>
    );
}

export default RelatedProductsShowMore;
